// extracted by mini-css-extract-plugin
module.exports = {"LinkVariantInline":"Link_LinkVariantInline__2eVA-","LinkColorPrimary":"Link_LinkColorPrimary__JGZmS","LinkUnderlined":"Link_LinkUnderlined__369Rm","Link":"Link_Link__2wMWF"};